import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { authFlowLog } from '../services/auth-flow-log';
import { CURRENT_APP_ID } from '../models/auth.model';
import { AuthStore } from '../stores/auth.store';

export const serviceGuard = (): boolean => {
  const authStore = inject(AuthStore);
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isE2eToken()) {
    authFlowLog(environment.debug, '7-guard:service-check', {
      allowed: true,
      e2e: true,
    });
    return true;
  }

  const services = authStore.services();
  const allowed = services.some(service => service.name === CURRENT_APP_ID);

  authFlowLog(environment.debug, '7-guard:service-check', {
    currentAppId: CURRENT_APP_ID,
    services: services.map(service => service.name),
    allowed,
  });

  if (allowed) {
    return true;
  }

  void router.navigate(['/403']);
  return false;
};
